import {Component, OnInit} from '@angular/core';
import {Batchloading} from '../../../model/Batchloading';
import {Page} from '../../../../global/util/enum/Page';
import {Constant} from '../../../../global/util/Constant';
import {BatchloadingService} from '../../../service/batchloading.service';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AuthService} from '../../../service/auth/auth.service';
import {Dialog} from '../../../../global/util/Dialog';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {InformType} from '../../../../global/util/enum/InformType';
import {Batchloadingdocument} from '../../../model/Batchloadingdocument';
import {BatchOperation} from '../../../../global/util/BatchOperation';
import {DatetimeformatPipe} from '../../../pipes/datetimeformat.pipe';
import {SearchBatchloadingdocument} from '../../../model/search/SearchBatchloadingdocument';
import {TranslateService} from '@ngx-translate/core';
import {StatesNotcer} from '../../../../global/util/StatesNotcer';
import {Pagination} from '../../../../global/util/Pagination';

@Component({
  selector: 'app-detail-batch-loading',
  templateUrl: './detail-batch-loading.component.html',
  styleUrls: ['./detail-batch-loading.component.css']
})
export class DetailBatchLoadingComponent implements OnInit {

  public title = 'TITLE.SHIPPING-DETAIL';
  public batchloadingdocuments: Batchloadingdocument[] = [];
  public batchloadingdocumentTotal: Batchloadingdocument[] = [];
  public batchloading: Batchloading;
  public page: any = {};
  public links: any = {};
  public enumPage = Page;
  public loading: boolean;
  public statusId: string;
  public totalNotification: string;
  // total de enviados a bandeja
  public trayTotal = 0;
  // total de notificados por correo
  public mailTotal = 0;
  // total de notificaciones visualizadas
  public visualizedTotal = 0;
  public DELIVERED = BatchOperation.DELIVERED;
  public SENT_2_MAIL = BatchOperation.SENT_2_MAIL;
  public VISUALIZED = BatchOperation.VISUALIZED;
  public searchBatchloadingdocument = new SearchBatchloadingdocument();
  pageNumber: any;
  pageNumbers: any[] = [];

  constructor(public sieCredentialService: BatchloadingService,
              private modalService: NgbModal,
              public activeModal: NgbActiveModal,
              public authService: AuthService,
              public translate: TranslateService) {
    Dialog.createInstance(modalService);
  }

  ngOnInit() {
    this.pageNumbers = Pagination.getNumbers();
    this.pageNumber = this.pageNumbers[Constant.ZERO_INDEX].value;
    this.statusId = StatesNotcer.ALL;
    this.searchBatchloadingdocument.batchloadingId = this.batchloading.id;
    this.search();
  }

  public loadDetails(page: Page, batchloadingId: number, documentNumber?: string, fullname?: string): void {
    documentNumber = documentNumber ? documentNumber : '';
    fullname = fullname ? fullname : '';
    let url;
    switch (page) {
      case Page.First:
        url = Constant.ROOT_API_V1.concat('/batchloadingdocuments/search?',
          'batchloading=', String(batchloadingId),
          '&batchoperationId=', String(this.statusId),
          '&documentNumber=', documentNumber,
          '&fullname=', fullname,
          '&size=', this.pageNumber,
          '&sort=id,desc');
        break;
      case Page.Previous:
        url = this.links.prev.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Next:
        url = this.links.next.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Last:
        url = this.links.last.href.replace('http', Constant.SCHEMA);
        break;
      default:
        url = this.links.self.href.replace('http', Constant.SCHEMA);
        break;
    }
    this.getDetails(url);
  }

  private getDetails(url: string): void {
    this.loading = true;
    this.title = this.translate.instant('TITLE.SHIPPING-DETAIL');
    this.sieCredentialService.get(url).subscribe((next: any) => {
      this.loading = false;
      if (next._embedded) {
        this.batchloadingdocuments = next._embedded.batchloadingdocuments;
        this.getAllDetails();
      } else {
        this.batchloadingdocuments = [];
      }
      this.page = next.page;
      this.links = next._links;
    }, error => {
      this.loading = false;
      if (HttpStatusCode.UNAUTHORIZED === error.error.status) {
        Dialog.show(InformType.Danger, this.title, error.error.message);
      } else {
        Dialog.show(InformType.Danger, this.title);
      }
    });
  }

  public hasRole(name: string): boolean {
    return this.authService.hasRole(name);
  }

  public hasAuthority(code: string): boolean {
    return this.authService.hasAuthority(code);
  }

  accept() {
    this.activeModal.close();
  }

  wasOpered(bld: Batchloadingdocument, batchoperationId: number): boolean {
    return bld.batchexecutions.find(value => value.batchoperationId === batchoperationId) !== undefined;
  }

  wasDelivered(bld: Batchloadingdocument): boolean {
    return this.wasOpered(bld, BatchOperation.DELIVERED);
  }

  wasSend2Email(bld: Batchloadingdocument): boolean {
    return this.wasOpered(bld, BatchOperation.SENT_2_MAIL);
  }

  wasVisualized(bld: Batchloadingdocument): boolean {
    return this.wasOpered(bld, BatchOperation.VISUALIZED);
  }

  iconClass(result: boolean): string {
    return result ? 'fa fa-check-circle custom-icon-success' : 'fa fa-times-circle custom-icon-danger';
  }

  message(bld: Batchloadingdocument, batchoperationId: number): string {
    const batchexecution = bld.batchexecutions.find(value => value.batchoperationId === batchoperationId);
    if (batchexecution) {
      return new DatetimeformatPipe().transform(batchexecution.createAt);
    }
    return '';
  }

  /**
   * Obtiene el total de cada estado de notificación
   */
  countBatchExecution(): void {
    this.totalNotification = this.batchloadingdocumentTotal.length + ' Notificaciones';
    this.trayTotal = this.batchloadingdocumentTotal.filter(value => value.batchexecutions.filter(value1 =>
      value1.batchoperationId === BatchOperation.DELIVERED).length > 0).length;
    this.mailTotal = this.batchloadingdocumentTotal.filter(value => value.batchexecutions.filter(value1 =>
      value1.batchoperationId === BatchOperation.SENT_2_MAIL).length > 0).length;
    this.visualizedTotal = this.batchloadingdocumentTotal.filter(value => value.batchexecutions.filter(value1 =>
      value1.batchoperationId === BatchOperation.VISUALIZED).length > 0).length;
  }

  /**
   * Realiza el filtro de las notificaciones por estado.
   */
  reloadBatchExecution(): void {
    this.search();
  }

  search(): void {
    const batchloadingId = this.searchBatchloadingdocument.batchloadingId;
    const documentNumber = this.searchBatchloadingdocument.documentNumber;
    const fullname = this.searchBatchloadingdocument.fullnamePerson;
    this.loadDetails(Page.First, batchloadingId, documentNumber, fullname);
  }

  private getAllDetails(): void {
    const batchloadingId = this.searchBatchloadingdocument.batchloadingId;
    const url = Constant.ROOT_API_V1.concat('/batchloadingdocuments/search1?',
      'batchloading=', String(batchloadingId));
    this.loading = true;
    this.title = this.translate.instant('TITLE.SHIPPING-DETAIL');
    this.sieCredentialService.get(url).subscribe((next: any) => {
      this.loading = false;
      if (next._embedded) {
        this.batchloadingdocumentTotal = next._embedded.batchloadingdocuments;
        this.countBatchExecution();
      } else {
        this.batchloadingdocumentTotal = [];
      }
    }, error => {
      this.loading = false;
      if (HttpStatusCode.UNAUTHORIZED === error.error.status) {
        Dialog.show(InformType.Danger, this.title, error.error.message);
      } else {
        Dialog.show(InformType.Danger, this.title);
      }
    });
  }
}
